<template>
  <v-container>
  
      <date-dialog ref="date" v-model="value.date" :label="$t('entities.environment.calendarExc.props.date')" format="DD/MM/YY" :required="true"></date-dialog>
      <time-picker ref="timeStart" v-model="value.start" :label="$t('entities.environment.calendarExc.props.start')" :required="true"></time-picker>
      <time-picker ref="timeEnd" v-model="value.end" :label="$t('entities.environment.calendarExc.props.end')" :required="true"></time-picker>
    
  </v-container>
</template>
<script>
//import moment from "moment";
export default {
  props: {
    value: {
      default: () => {
        return {
          date: null,
          start: null,
          end: null
        };
      }
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    isValid(){
      return this.$refs.date.isValid() && 
      this.$refs.timeStart.isValid() && 
      this.$refs.timeEnd.isValid();
       
    }
  },
};
</script>